import useGetOfferMockups from './useGetOfferMockups'

export default useGetOfferMockups
